import { fromConsignmentItemDetailsResponseV3 } from '../models/mapper'
import { ConsignmentItemDetails } from '../models/types'
import { duplicateConsignmentItemV3 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function duplicateConsignmentItem(id: number): Promise<ConsignmentItemDetails> {
  const response = await duplicateConsignmentItemV3(id)
  return fromConsignmentItemDetailsResponseV3(response)
}
